import { useEffect, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import PropTypes from "prop-types";
import TableForm2s from "../../../../components/TableFormScrb";
import { formatDate } from "../../../../commons/FormatValue";
import { useNavigate } from "react-router-dom";
import ServiceRequestService from "../../../../services/servicerequest.service";
import SequenceStatusService from "../../../../services/sequencestatus.service";
import FileUploadsService from "../../../../services/fileupload.service";
import TechWorkClosedService from "../../../../services/techworkclose.service";

export default function CloseJob({ defaultData }) {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [WorkNo, setWorkNo] = useState([]);
  const [seqStsMas, setSeqStsMas] = useState([]);

  useEffect(() => {
    setJobType(defaultData.job_type)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: SequenceStatusService.getAllSequenceStatuses(),
      callback: (res) => setSeqStsMas(res)
    });
  }, [defaultData]);

  const columns = [
    {
      name: "ModelNumber",
      label: "ประเภทงาน",
      readOnly: true,
      format: (row) => JobType.find(item => item.Id === row.Job_Type_Id)?.Job_Type_Name,
      width: "180px"
    },
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      readOnly: true,
      width: "250px"
    },
    {
      name: "Work_Date",
      label: "วันที่ปฏิบัติงาน",
      readOnly: true
    },
    {
      name: "Depart_St_Name",
      label: "สถานะงาน",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Seq_St_Name",
      label: "สถานะใบสั่งงาน",
      readOnly: true
    },
    {
      name: "TechWorkClosedFile",
      label: "ลายเซ็นลูกค้า",
      readOnly: true,
      type: "image"
    },
    {
      name: "Status_Cus",
      label: "สถานะลูกค้า",
      readOnly: true,
      onClick: (row) => row && navigate(`/service_work/perform/close`, {
        state: { name: "CloseJob", data: row, arrJobType: JobType }
      }),
    },
  ];

  const searchInput = [
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 4
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.team,
      disabled: true,
      size: 4
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 4,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "start",
      label: "วันที่ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      max: "updatedAt"
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      min: "createdAt"
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechWorkClosedService.getSeqNo(q),
          callback: (array) => {
            const newArray = array.data?.map(arr => ({
              seq_no: arr.seqJob.seqNo
            }))
            setWorkNo(newArray)
          }
        });
      }
    },
  ];

  const getDataTable = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = getQueryString({ page: page, limit: limit, ...search })
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechWorkClosedService.getJob(q),
      callback: (res) => { initData(res.data); setAllCountData(res.allCount) }
    });
  }
  async function initData(data) {
    const newArray = await Promise.all(data?.map(async (items) => {
      let blob
      try {
        blob = await FileUploadsService.getFileUploads(
          "signature",
          items.TechnicianPlan?.TechWorkClosed?.TechWorkClosedFile?.file_path
        )
      } catch (error) {
        console.log(error)
      }

      return {
        ...items,
        Work_Date: formatDate(items.TechnicianPlan?.TechWorkClosed?.tech_work_close_date),
        Job_Type_Id: items.BillOfReqHd?.Job_Type_Id,
        Seq_No: items.TechnicianPlan?.seq_no,
        Cus_Code: items?.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Code ||
          items?.TechnicianPlan?.SeqInstalljob?.InformInstallJobs.Customer?.Cus_Code,
        Cus_Name: items?.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Name ||
          items?.TechnicianPlan?.SeqInstalljob?.InformInstallJobs.Customer?.Cus_Name,
        Job_Cus_Date: formatDate(items.SeqOthersJob?.InformOtherJob?.Job_Cus_Date),
        Depart_St_Name: items.TechnicianPlan?.DepartJob?.Depart_St_Name,
        Seq_St_Name: seqStsMas?.find(st => st.Id == items.TechnicianPlan?.DepartJob?.Seq_St_Id)?.Seq_St_Name,
        Status_Cus: items.TechnicianPlan?.TechWorkClosed?.cus_accepted ? "รับงานแล้ว" : "รอตรวจรับ",
        TechWorkClosedFile: blob && URL.createObjectURL(blob)
      }
    }));

    setTableData(newArray || [])
  }

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Body>
          <InputSearch
            inputField={searchInput}
            field={searchInput}
            searchCallback={search => search ? getDataTable(search) : setTableData([])}
          />
        </Card.Body>
      </Card>

      <Form noValidate>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">

            </Card.Title>

            <Button
              variant="success"
              className="me-2 px-5 py-2 text-dark rounded-pill h-100"
              onClick={() => navigate("report",
                { state: { arrJobType: JobType } }
              )}
            >
              ข้อมูลหมายเลข Service Report
            </Button>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={tableData}
              columns={columns}
              pending={loading}
              editForm={false}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              rowCount={allCountData}
            />
          </Card.Body>
        </Card>
      </Form>
    </>
  );
}

CloseJob.propTypes = {
  defaultData: PropTypes.object,
};